import { Injectable } from "@angular/core";
import * as fromRoot from "@app/store";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(private store: Store<fromRoot.State>) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectIsAuthenticated()),
      map((isAuthed) => {
        if (isAuthed) {
          return true;
        } else {
          this.store.dispatch(fromRoot.loginRedirect());

          return false;
        }
      }),
      take(1),
    );
  }
}
